<template>
  <div>
    <div v-if="this.$route.query.type=='ispcloud'">
      <div class="app1">
        <keep-alive>
          <router-view />
        </keep-alive>
      </div>
    </div>
    <div v-else-if="this.$route.query.id">
      <div class="app">
        <ArticleContent :id="this.$route.query.id" />
      </div>
      <div class="macc">
        <div id="nav">
          <HeadMenu />
        </div>
        <keep-alive>
          <router-view />
        </keep-alive>
        <div id="foot">
          <FootLogo />
        </div>
      </div>
    </div>
    <div v-else>
        <div id="nav">
          <HeadMenu />
        </div>
        <keep-alive>
          <router-view />
        </keep-alive>
        <div id="foot">
          <FootLogo />
        </div>
    </div>
  </div>
</template>

<script>
import HeadMenu from "@/components/HeadMenu.vue";
import FootLogo from "@/components/FootLogo.vue";
// 适配移动端，小屏直接显示文章
import ArticleContent from "@/views/ArticleContent.vue";
import { initStatisticsComp } from '@/utils/statisticsMgr.js';
export default {
  components: {
    HeadMenu,
    FootLogo,
    ArticleContent,
  },
  watch: {
    $route(to, from) {
      if (to.path.includes('/isp')) {
        sessionStorage.setItem("isIsp", true);
      }  else if (to.path === '/') { 
        sessionStorage.setItem("isIsp", false);
      }
    }
  },
  mounted() {
    initStatisticsComp();
    let sessionID = window.sessionStorage.activeId;
    let localID = window.localStorage.activeId;
    localID = localID ? localID : "游客";
    let userid = sessionID ? sessionID : localID;
    this.GLOBAL.userid = userid;
    console.log("this.GLOBAL", this.GLOBAL);

    if (this.$route.path.includes('/isp')) {
      sessionStorage.setItem("isIsp", true);
    } else if (this.$route.path === '/' && location.href.endsWith('help/#/')) { 
      sessionStorage.setItem("isIsp", false);
    }
  },
  beforeDestroy() {
    console.log(
      "macc-help-文档中心-用户统计,this.GLOBAL.count",
      this.GLOBAL.count
    );
    // 发送诸葛io埋点数据
    this.zhugePoint("macc-help-文档中心-用户统计", {
      userid: this.GLOBAL.userid, //用户id
      enterTime: this.GLOBAL.enterTime, //用户进入文档系统的时间
      outTime: new Date(), //用户离开文档系统的时间
      count: this.GLOBAL.count, //全局阅读文章数
    });
  },
};
</script>
<style lang="scss">
@media screen and (max-width: 1000px) {
  .macc {
    display: none !important;
  }
  .app {
    width: 100vw;
  }
}
@media screen and (min-width: 1101px) {
  .app {
    display: none !important;
  }
}
.warper {
  // width: 68vw;
  // min-width: 1200px !important;
  // max-width: 1377px;
  max-width: 1200px;
  margin: 0px auto;
}
.hoverColor:hover {
  color: #2b6afd !important;
}
.pointer {
  cursor: pointer;
}
html::-webkit-scrollbar {
  width: 5px;
}
.html::-webkit-scrollbar-track {
  background: rgb(235, 234, 234);
  border-radius: 5px;
}
.html::-webkit-scrollbar-thumb {
  background: rgb(199, 199, 199);
  border-radius: 5px;
}
.html::-webkit-scrollbar-thumb:hover {
  background: rgb(199, 199, 199);
  border-radius: 5px;
}
.html::-webkit-scrollbar-thumb:active {
  background: rgb(141, 141, 141);
  border-radius: 5px;
}
</style>
